import React, { useState } from "react";
import Popup from "./Popup";

function ButtonWithDangerous({
  buttonText,
  onClick,
  jsxElement,
  title,
  description,
  className,
  buttonIcon,
  ariaLabel,
}) {
  const [active, setActive] = useState(false);
  return (
    <>
      <button
        aria-label={ariaLabel}
        onClick={(e) => {
          e.preventDefault();
          setActive(true);
        }}
        className={className}
      >
        {buttonIcon}
        {buttonText}
      </button>
      <Popup active={active} setActive={setActive}>
        <header className="modal-alert__header">
          <h1 className="modal-alert__title">{title}</h1>
        </header>
        <div className="modal-alert__description">
          <p>{description}</p>
        </div>
        {jsxElement}
        <div className="modal-alert__actions">
          <button
            onClick={(e) => {
              e.preventDefault();
              setActive(false);
            }}
            className="modal-alert__button"
          >
            Нет
          </button>
          <button
            onClick={(e) => {
              onClick(e);
              setActive(false);
            }}
            className="modal-alert__button modal-alert__button_yes"
          >
            Да
          </button>
        </div>
      </Popup>
    </>
  );
}

export default ButtonWithDangerous;
